import setViewportHeight from "./modules/setViewportHeight";
import setFixedOffset from "./modules/setFixedOffset";
import preloader from "./modules/preloader";
// import lazyLoad from "./modules/lazyLoad";
import initializeNavigation from "./modules/initializeNavigation";
import rellax from "./modules/rellax";
// lazyLoad.beLazy();

window.addEventListener("resize", () => {
  setViewportHeight();
});

window.addEventListener("DOMContentLoaded", () => {
  setViewportHeight();
  setFixedOffset();
  initializeNavigation();
  rellax();
  preloader.init();
});
